import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import Navigation from '@/components/Navigation';
import ServiceNavigation from '@/components/ServiceNavigation';

const ConsultingPage = () => {
  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-pearl-50/50 via-white to-ocean-25/30">
        {/* Service Navigation */}
        <div className="pt-20">
          <ServiceNavigation currentService="consultoria" />
        </div>

        {/* Hero Section */}
        <motion.div
          className="relative py-16 px-4 sm:px-6 lg:px-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              className="inline-flex items-center gap-3 mb-6"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="w-16 h-16 bg-gradient-to-r from-coral-500 to-coral-600 rounded-2xl flex items-center justify-center text-white shadow-lg">
                <Users className="w-8 h-8" />
              </div>
              <div>
                <h1 className="text-4xl sm:text-5xl font-bold text-transparent bg-gradient-to-r from-coral-600 to-ocean-600 bg-clip-text font-heading">
                  Consultoría Gastronómica
                </h1>
              </div>
            </motion.div>
            
            <motion.p 
              className="text-xl text-deep-600 max-w-2xl mx-auto leading-relaxed mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Asesoramiento profesional para restaurantes y chefs que desean incorporar 
              mariscos premium en sus menús.
            </motion.p>

            <motion.div
              className="bg-coral-50/50 rounded-2xl p-8 border border-coral-200/30"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h3 className="text-2xl font-bold text-coral-700 mb-4">
                Página en Desarrollo
              </h3>
              <p className="text-coral-600 mb-6">
                Estamos trabajando en esta sección para ofrecerte la mejor información 
                sobre nuestros servicios de consultoría gastronómica.
              </p>
              <Link 
                to="/servicios"
                className="inline-flex items-center bg-gradient-to-r from-coral-500 to-coral-600 text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90 transition-opacity"
              >
                Ver Todos los Servicios
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default ConsultingPage;
